// extracted by css-extract-rspack-plugin
export default {"footerLink":"footer-fragment__FooterLinkItem_footerLink__uLJiZ"};